import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'
import api from 'api'

const FETCH_REQUEST = 'realhub/providerPriceListItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/providerPriceListItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/providerPriceListItem/FETCH_FAILURE'
const CREATE_REQUEST = 'realhub/providerPriceListItem/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/providerPriceListItem/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/providerPriceListItem/CREATE_FAILURE'
const UPDATE_REQUEST = 'realhub/providerPriceListItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/providerPriceListItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/providerPriceListItem/UPDATE_FAILURE'
const DELETE_REQUEST = 'realhub/providerPriceListItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/providerPriceListItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/providerPriceListItem/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  result: [],
  loaded: false,
  loading: false,
  errors: [],
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
    loading: true,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadPriceListItems(options){
  return (dispatch) => {
    // Set Loading
    dispatch(fetchRequest())

    // Encode Params
    const promise = api(`/admin/providers/${options.provider_id}/provider_price_list_items.json`)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        return dispatch(fetchSuccess({ result: normalizedJson.result }))
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createPriceListItem(priceListItem, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      provider_price_list_item: priceListItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api('/admin/provider_price_list_items.json', options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function updatePriceListItem(priceListItem, options, callback){
  const config = {
    method: 'PUT',
    body: JSON.stringify({
      provider_price_list_item: priceListItem,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/provider_price_list_items/${priceListItem.id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))
      })

    return promise
  }
}

export function deletePriceListItem(priceListItem, callback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const promise = api(`/admin/provider_price_list_items/${priceListItem.id}.json`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }
        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })
    return promise
  }
}

export function duplicatePriceListItem(priceListItem, options, callback){
  const config = {
    method: 'POST',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const promise = api(`/admin/provider_price_list_items/${priceListItem.id}/duplicate.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_PRICE_LIST_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        errors: [],
      })
    case UPDATE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
      })
    default:
      return state
  }
}
